import { Paper, Box, Typography, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, SxProps, useTheme } from "@mui/material";
import { MemberContactEmail, MemberContactPhone } from "../../../clients";

interface MyAccountMembershipContactInfoProps {
    sx?: SxProps
    phones: MemberContactPhone[]
    emails: MemberContactEmail[]
}

export const MyAccountMembershipContactInfo = ({ sx, phones, emails }: MyAccountMembershipContactInfoProps) => {

    const theme = useTheme()

    const renderPhoneNumberRow = (phoneNumber: MemberContactPhone) => {
        return (
            <PhoneNumberRow
                key={phoneNumber.phone}
                phoneNumber={phoneNumber}
            />
        )
    }

    const renderEmailRow = (email: MemberContactEmail) => {
        return (
            <EmailRow
                key={email.email}
                email={email}
            />
        )
    }

    return (
        <Paper sx={{ ...sx, border: '1px solid', borderColor: theme.palette.secondary.main, borderRadius: '3px', p: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography>Contact Information</Typography>
            </Box>
            <TableContainer sx={sx} component={Box}>
                <Table sx={{ minWidth: 500 }} aria-label='Phones'>
                    <TableHead>
                        <TableRow>
                            <TableCell>Phone</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {phones.map(renderPhoneNumberRow)}
                    </TableBody>
                </Table>
            </TableContainer>
            <TableContainer sx={sx} component={Box}>
                <Table sx={{ minWidth: 500 }} aria-label='Emails'>
                    <TableHead>
                        <TableRow>
                            <TableCell>Email</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {emails.map(renderEmailRow)}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    )
}

interface PhoneNumberRowProps {
    phoneNumber: MemberContactPhone
}

const PhoneNumberRow = ({ phoneNumber }: PhoneNumberRowProps) => {

    return (
        <TableRow key={phoneNumber.memberId}>
            <TableCell>{phoneNumber.phone}</TableCell>
        </TableRow>
    )
}

interface EmailRowProps {
    email: MemberContactEmail
}

const EmailRow = ({ email }: EmailRowProps) => {
    return (
        <TableRow key={email.email}>
            <TableCell>{email.email}</TableCell>
        </TableRow>
    )
}